import type { TableRowType } from 'components/editor/grid/reduxStore/table.types';

export const crmArrayIdentity = (template: string): string => template.slice(0, template.lastIndexOf('.'));

export function rowCrmArrayConflict(row: TableRowType | undefined, incomingTemplate: string | null | undefined): boolean {
  if (!row?.crmFieldInstances || !incomingTemplate) return false;
  const incomingArray = crmArrayIdentity(incomingTemplate);
  return Object.values(row.crmFieldInstances).some((instances) =>
    instances.some((instance) => instance.template && crmArrayIdentity(instance.template) !== incomingArray)
  );
}
